/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import blue from './blue';
import common from './common';
import dusk from './dusk';
import gray from './gray';
import green from './green';
import indigo from './indigo';
import lime from './lime';
import magenta from './magenta';
import orange from './orange';
import purple from './purple';
import red from './red';
import sky from './sky';
import slate from './slate';
import teal from './teal';
import yellow from './yellow';

/* @flow */
export default {
  ...blue,
  ...common,
  ...dusk,
  ...gray,
  ...green,
  ...indigo,
  ...lime,
  ...magenta,
  ...orange,
  ...purple,
  ...red,
  ...sky,
  ...slate,
  ...teal,
  ...yellow
};



// WEBPACK FOOTER //
// ./src/colors/palette.js